import React from 'react'

import PopupMenuButton from "../../../../../../core/gd-components/popover-menu/popup-menu-button/popup-menu-button"
import SubmenuRequestsAndFormsMenuOptions from "./menu-options"
import ProjectView from "../../../../../../core/model2/project-view/project-view"

type Props = {
    style?      : any

    projectView : ProjectView
}

export default class SubmenuRequestsAndForms extends React.Component<Props> {

    renderButton = (state:any) => {
        return (
            <div className="item m-r-10" style={this.props.style}>
                <div className="label max-w-200">
                    {this.props.projectView.name}
                </div>
                <div className="ui5-triangle-toggle s7 open"/>
            </div>
        )
    }

    render() {
        return <PopupMenuButton btnComponent        = {this.renderButton}
                                attachment          = "top center"
                                targetAttachment    = "bottom center"
                                offset              = "0 0"
                                menuComponent       = {SubmenuRequestsAndFormsMenuOptions}
                                menuParams          = {{
                                    project: this.props.projectView.projectViews.project
                                }}/>

    }
}